<template>
  <svg width="30" height="30" viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg" fill="#37AAEC">
    <path d="M13.4943 16.002C13.4943 9.92578 8.79582 5 3 5V13.8975C3 19.9738 7.69844 24.8995 13.4943 24.8995V16.002Z" fill="inherit" />
    <path d="M26.8461 16.0655H16.3518V25H18.3239C23.0306 25 26.8461 20.9999 26.8461 16.0655Z" fill="inherit" />
    <path d="M16.3519 5H26.8462V13.9345H16.3519V5Z" fill="inherit" />
  </svg>
</template>
